  <div>
    <div class="list-benefits">

      <nz-table *ngIf="benefitList && benefitList.length > 0" [nzData]="[1]" [nzShowPagination]="false" class="valign-top">
        <thead>
          <tr>
            <th>Cover Name</th>
            <th>Benefit</th>
            <!-- <th>Event</th> -->
            <th>Benefit Amount</th>
            <th>Approved Amount</th>
            <th>Decision</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody class="valign-top">
          <tr class="v-a-top" *ngFor="let item of benefitList">
            <td>{{item.productCd}}</td>
            <td>{{item.benefitCd}}</td>
            <!-- <td>{{item.Event}}</td> -->
            <td>{{item.benefitAmt}}</td>
            <td>
              <nz-input-group nzAddOnBefore="Rs.">
                <input nz-input placeholder="Enter Amount" nzSize="large" [(ngModel)]="item.benefitAmt"
                  (ngModelChange)="updateBenefitTotal(benefitList)" />
              </nz-input-group>
            </td>
            <td>
              <nz-select nzShowSearch  style="width: 100%;min-width: 110px;" [(ngModel)]="item.decisionCd">
                <nz-option
                  *ngFor="let data of (lookup$.manualAdjDecisionCd | async) as manualAdjDecisionCd; trackBy:item?.lookupKey"
                  [nzLabel]="data?.lookupValue" [nzValue]="data?.lookupKey">
                </nz-option>
              </nz-select>


            </td>
            <td><textarea nz-input cols="30" rows="2" [(ngModel)]="item.note" placeholder="Notes"></textarea>
            </td>
          </tr>

          <tr class="v-a-top">
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><span class="f-w-600">Total Approved</span></td>
            <td>
              <span class="f-s-1-7r col-red">
                {{totalAmount}}
              </span>
            </td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>

        </tbody>
      </nz-table>

      <app-generic-zero-ui [list]="benefitList" icon="file-search" [title]="benefitZeroState.title" [message]="benefitZeroState.message"></app-generic-zero-ui>

    </div>
  </div>
